import { Pipe } from '@angular/core';
import { Proxy } from '../services/proxy/proxy.service';

@Pipe({
  name: 'PorCodigoAmonestacionPipe',
})
export class PorCodigoAmonestacionPipe {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value, args?) {
    let val: string = args;
    return value.filter((item: Proxy.PrCodigoAmonestacion) => {
      if (val.length > 0) {
        if (!isNaN(parseInt(val))) {
          // Es un número, por lo que se comparará con el código de cada amonestación
          return item.Codigo == parseInt(val);
        }
        else {
          // No es un número, por lo que se comparará con el hecho
          return item.Hecho.toLowerCase().indexOf(val.toLowerCase()) > -1;
        }
      }
      else {
        return true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/por-codigo-amonestacion.ts